import { USER_STATUS, USER_STATUS_JA, LANGUAGE } from '../../../constants';
import type { ProcessCellCallbackParams } from '../../../types/common';
import type { Language, SelectOption } from '../../../types/common';

const userStatusCellCallback = (params: ProcessCellCallbackParams): string => {
  const value = params.value;
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const formattedValue: string = currentLang ? (currentLang.value === LANGUAGE.JA ? USER_STATUS_JA[value] : USER_STATUS[value]) : value;
  return formattedValue;
};

export default userStatusCellCallback;
